import { useQuery } from '@tanstack/react-query';
import { useApi } from '../useApi';

export function useUsers() {
  const getApi = useApi();

  const getUsers = async () => {
    const api = await getApi();

    const res = await api.customerUserFindColleagues(100, 0);
    return res.data;
  };

  const query = useQuery({
    queryKey: ['users'],
    queryFn: getUsers,
    keepPreviousData: false,
  });

  return {
    ...query,
  };
}
